export type IfDefinitionReportRequest = {
  type: string;
  dfnSetVerNum: string;
  pjtId: string;
};
